import lodash from 'lodash';

export default function prefillFormData(defaultForm, existingForm) {
  lodash.merge(defaultForm, existingForm);
}
